import { render } from "./static-button-conf.vue?vue&type=template&id=7bfbe000&scoped=true"
import script from "./static-button-conf.vue?vue&type=script&lang=js"
export * from "./static-button-conf.vue?vue&type=script&lang=js"

import "./static-button-conf.vue?vue&type=style&index=0&id=7bfbe000&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfbe000"]])

export default __exports__